/* eslint no-process-env:0 */
import React                        from 'react';
import {
 Route,
 Switch,
 Redirect
}                                   from 'react-router-dom';
import HomeConnected                from '../views/home';
import RevenueConnected             from '../views/revenue';
import BatchHealthConnected         from '../views/batchhealth';
import CustomersConnected           from '../views/customers';
import LeadsConnected               from '../views/leads';
import LeadsBulkConnected           from '../views/partner/crud/addLeadBulk';
import SalesConnected               from '../views/sales';
import SessionsConnected            from '../views/sessions';
import CohortConnected              from '../views/cohort';
import CollectionConnected          from '../views/collection';

import AlertConnected               from '../views/alert';
import BasicElementsConnected       from '../views/basicElements';
import BasicProgressBarConnected    from '../views/basicProgressBar';
import BreadcrumbViewConnected      from '../views/breadcrumb';
import EarningGraphConnected        from '../views/earningGraph';
import GeneralConnected             from '../views/general';
import NotificationsConnected       from '../views/notifications';
import PageNotFoundConnected        from '../views/pageNotFound';
import PaginationViewConnected      from '../views/pagination';
import SimpleTablesConnected        from '../views/simpleTables';
import StatViewConnected            from '../views/stat';
import StatsCardConnected           from '../views/statsCard';
import StripedProgressBarConnected  from '../views/stripedProgressBar';
import TabPanelConnected            from '../views/tabPanel';
import TeamMatesViewConnected       from '../views/teamMates';
import TodoListViewConnected        from '../views/todoList';
import TwitterFeedConnected         from '../views/twitterFeed';
import WorkProgressConnected        from '../views/workProgress';

import PartnerDashboardConnected    from '../views/partner/partnerDashboard';
import PartnerBFCConnected    from '../views/partner/partnerBFC';
import PartnerBBFSConnected         from '../views/partner/partnerBBFS';
import PartnerFootballConnected     from '../views/partner/partnerFootball';
import PartnerPlayConnected         from '../views/partner/partnerPlay';
import PartnerRentalConnected       from '../views/partner/partnerRental';
import PartnerBadmintonConnected    from '../views/partner/partnerBadminton';
import PartnerBadmintonAcademyConnected    from '../views/partner/partnerBadmintonAcademy';
import PartnerBadmintonPlayConnected    from '../views/partner/partnerBadmintonPlay';
import PartnerTournamentConnected   from '../views/partner/partnerTournament';
import PartnerSummerConnected       from '../views/partner/partnerSummer';
import PartnerSummerBadmintonConnected       from '../views/partner/partnerSummerBadminton';
import PartnerKidslistConnected       from '../views/partner/partnerKidslist';
import PartnerReportsConnected    from '../views/partner/partnerReports';

import CreateFixtureConnected                   from '../views/partner/crud/createFixture';
import CustomerDetailsConnected                        from '../views/partner/crud/customerDetails';
import TargetDetailsConnected                        from '../views/centerportal/targetDetails';
import AbsenteeReasonConnected                        from '../views/partner/crud/absenteeReason';
import EditFixtureConnected                     from '../views/partner/crud/editFixture';
import AddRentalConnected                       from '../views/partner/crud/addRental';
import AddLeadConnected                       from '../views/partner/crud/addlead';
import AddTournamentTeamMemberConnected         from '../views/partner/crud/addTournamentTeamMember';
import AddTournamentConnected                   from '../views/partner/crud/addTournament';
import AddTeamConnected                         from '../views/partner/crud/addTeam';
import ViewTournamentConnected                  from '../views/partner/crud/viewTournament';

import AddCompetitionConnected                  from '../views/partner/crud/addCompetition';
import ViewCompetitionConnected                  from '../views/partner/crud/viewCompetition';
import AddCompetitionStructureConnected            from '../views/partner/crud/addCompetitionStructure';
import AddCompetitionExpenseConnected            from '../views/partner/crud/addCompetitionExpense';
import EditCompetitionExpenseConnected            from '../views/partner/crud/editCompetitionExpense';
import AddCompetitionTeamConnected            from '../views/partner/crud/addTournamentTeam';
import EditCompetitionTeamConnected            from '../views/partner/crud/editTournamentTeam';
import DeleteCompetitionTeamConnected            from '../views/partner/crud/deleteCompetitionTeam';

import AddSubscriptionConnected                 from '../views/partner/crud/addSubscription';
import AddSubscriptionPPGConnected              from '../views/partner/crud/addSubsForPayPerGame';
import AddTournamentTeamConnected               from '../views/partner/crud/addTournamentTeam';
import AddTournamentFixtureConnected            from '../views/partner/crud/addTournamentFixture';

import AddTournamentTasksConnected            from '../views/partner/crud/addTournamentTasks';
import HostGameConnected                        from '../views/partner/crud/hostGame';
import EditHostedGameConnected                        from '../views/partner/crud/editHostedGame';
import PartnerNotificationConnected             from '../views/partner/partnerNotification';
import CancelSessionConnected                       from '../views/partner/crud/cancelSession';
import DeleteFixtureConnected                   from '../views/partner/crud/deleteFixture';
import DeleteTournamentConnected                from '../views/partner/crud/deleteTournament';
import DeleteMatchConnected                from '../views/partner/crud/deleteMatch';
import DeleteTeammemberConnected                from '../views/partner/crud/deleteTeammember';
import DeleteTeamConnected                from '../views/partner/crud/deleteTeam';
import EditTournamentConnected                  from '../views/partner/crud/editTournament';
import EditTeamConnected                        from '../views/partner/crud/editTeam';
import EditMatchConnected                       from '../views/partner/crud/editMatch';
import EditStatsConnected                       from '../views/partner/crud/editStats';
import EditLeadConnected                       from '../views/partner/crud/editLead';
import EditProfileConnected                       from '../views/partner/crud/editProfile';
import ChildProfileConnected                       from '../views/partner/crud/childProfile';
import FeedbackStatusConnected                       from '../views/partner/crud/feedbackStatus';
import EditTournamentSubscriptionConnected      from '../views/partner/crud/editTournamentSubscription';
import ScheduleDemoConnected                       from '../views/partner/crud/scheduleDemo';
import requireAuthentication                    from '../services/auth';
import AddEventConnected                        from '../views/partner/crud/addEvent';
import EditEventConnected                       from '../views/partner/crud/editEvent';
import CancelBookingConnected                   from '../views/partner/crud/cancelBooking';
import UnblockingCourtsConnected                   from '../views/partner/crud/unblockingCourts';

import TournamentPricingConnected                   from '../views/partner/crud/tournamentPricing';

import SessionObjectiveConnected                   from '../views/partner/crud/sessionObjective';

import AddBulkBookingConnected                     from '../views/partner/crud/addBulBooking';
import EditCourtPricingConnected                     from '../views/partner/crud/editCourtPricing';
import EditRevenueTargetConnected                     from '../views/partner/crud/editRevenueTarget';
import UpdateCourtBookingConnected              from '../views/partner/crud/updateCourtBooking';
import FoodRentalConnected              from '../views/partner/crud/foodRental';
import PartnerCourtBookingConnected         from '../views/partner/partnerCourtBooking';
import PartnerBulkBookingConnected         from '../views/partner/partnerBulkbooking';
import AddNearbyPlaceConnected                    from '../views/partner/crud/addNearbyPlace';
import EditPlaceConnected                         from '../views/partner/crud/editPlace'

import EditTargetConnected                  from '../views/partner/crud/editTarget';
import DailyRevenueConnected                  from '../views/partner/partnerrevenue';
import MarketingConnected                     from '../views/marketing';
import CheckIn                              from '../views/centerportal/crud/checkin';
import CheckOut                              from '../views/centerportal/crud/checkout';

import ExpensesConnected                              from '../views/centerportal/crud/expenses';
import EditExpensesConnected                              from '../views/centerportal/crud/editexpense';
import TicketStatusConnected                       from '../views/partner/crud/ticketStatus';
import CallStatusConnected                       from '../views/partner/crud/callStatus';
import PartnerTasksConnected                     from '../views/partner/partnerTasks';
import PartnerWorkBenchConnected                     from '../views/partner/partnerWorkBench';
import PartnerTVConnected                        from '../views/partner/partnerTV';
import ResponseLeadsConnected                       from '../views/partner/responseLeads';
import DemoScheduledLeads                         from '../views/partner/demoScheduledLeads';
import UpdateRentalConnected                      from '../views/partner/crud/updateRental';
import RevenueTargetConnected                            from '../views/centerportal/revenueTarget';
import CreateVenueConnected                     from '../views/centerportal/crud/createVenue';
import VenueCommonConnected                    from '../views/centerportal/crud/venueCommon';
import EditVenueConnected                       from '../views/centerportal/crud/editVenue';
import EditCourtConnected                       from '../views/centerportal/crud/editCourt';
import AddCourtConnected                        from '../views/centerportal/crud/addCourt';
import CourtList                                from '../views/centerportal/crud/addCourt/CourtList.js';
import AddBuddyConnected                        from '../views/centerportal/crud/addBuddy';
import UpdateBuddyConnected                     from '../views/centerportal/crud/updateBuddy';
import FixtureInfoConnected                     from '../views/centerportal/fixtureInfo/FixtureInfo';

import AddLocationConnected                     from '../views/centerportal/crud/addLocation';

import AddInventoryItemConnected                        from '../views/centerportal/crud/addInventoryItem';
import AddInventoryEntryConnected                        from '../views/centerportal/crud/addInventoryEntry';

import PartnerAllocationConnected               from '../views/partner/partnerAllocation';
import PartnerExpenseConnected                  from '../views/partner/partnerExpense';

import VenueListConnected                       from '../views/centerportal/venueList';
import VenueDetailsConnected                    from '../views/centerportal/venueDetails';
import VenueInfoConnected                    from '../views/centerportal/venueInfo';
import DashboardConnected                       from '../views/centerportal/dashboard';
import InventoryConnected                       from '../views/centerportal/inventory';
import CustomerListConnected                    from '../views/centerportal/customerList';

import CustomerBasicList                        from '../views/centerportal/customerBasicList';
import BatchHealthCustomers                        from '../views/centerportal/batchHealthCustomers';
import CollectionListConnected                    from '../views/centerportal/CollectionList';
import CollectionDetailsConnected                    from '../views/centerportal/CollectionDetails';
import RevenueListConnected                    from '../views/centerportal/RevenueList';
import RevenueDetailsConnected                    from '../views/centerportal/RevenueDetails';
import RevenueBreakupConnected                    from '../views/centerportal/RevenueBreakup';

import BookingListConnected                     from '../views/centerportal/bookingList';
import ExpenseReportConnected                   from '../views/centerportal/expenseReport';
import AddExpenseTargetConnected                from '../views/centerportal/crud/addExpenseTarget';
import ExpenseRecordsConnected                  from '../views/centerportal/crud/expenseRecords';
import ExpenseListConnected                     from '../views/centerportal/expenseList';
import ExpenseDetailsConnected                  from '../views/centerportal/expenseDetails';

import CourtBookingListConnected                from '../views/centerportal/courtBookingList';
import BulkBookingListConnected                 from '../views/centerportal/bulkBookingList';
import EquipmentRentalListConnected             from '../views/centerportal/equipmentRentalList';
import ItemsSoldListConnected                   from '../views/centerportal/itemsSoldList';
import BookingSourceListConnected               from '../views/centerportal/bookingSourceList';

import CustomerFeedbackConnected                from '../views/centerportal/customerFeedback';

import BulkPauseConnected                       from '../views/centerportal/bulkPause';
import BatchDetails                             from '../views/centerportal/batchDetails'
import SessionDetails                             from '../views/centerportal/sessionDetails'
import LeadsDailyList                             from '../views/centerportal/leadsDailyList'
import LeadsDetails                       from '../views/centerportal/LeadsDetails'
import RenewalAnalysis                    from '../views/centerportal/renewalAnalysis'
import RenewalAnalysisReport              from  '../views/centerportal/renewalAnalysisReport'

export const MainRoutes = ({superUser, partner}) => (
  <Switch>
    <Route exact path="/" component={DashboardConnected}/>
    <Route exact path="/dashboard/:section" component={DashboardConnected}/>
    <Route exact path="/dashboard" component={DashboardConnected}/>
    <Route exact path="/inventory" component={InventoryConnected}/>
    <Route exact path="/inventory/:section" component={InventoryConnected}/>
    <Route exact path="/old-dash" component={HomeConnected}/>
    <Route exact path="/tasks" component={PartnerTasksConnected}/>
    <Route exact path="/work-bench" component={PartnerWorkBenchConnected}/>
    <Route exact path="/work-bench/:selected_tab" component={PartnerWorkBenchConnected}/>
    <Route exact path="/work-bench/ticket_and_lead/:selected_tab" component={PartnerWorkBenchConnected}/>
    <Route exact path="/expense" component={PartnerExpenseConnected}/>
    <Route exact path="/tv" component={PartnerTVConnected}/>
    <Route exact path="/RevenueTarget" component={RevenueTargetConnected}/>
    <Route exact path="/fixtureInfo/:id" component={FixtureInfoConnected}/>
    <Route exact path="/fixtureInfo/:id/:selected_tab" component={FixtureInfoConnected}/>
    <Route exact path="/batchDetails/" component={BatchDetails}/>
    <Route exact path="/sessionDetails/" component={SessionDetails}/>
    <Route exact path="/leadsDailyList/" component={LeadsDailyList}/>
    // <Route exact path="/revenue" component={RevenueConnected} />
    // <Route exact path="/collection" component={CollectionConnected} />
    // <Route exact path="/sales" component={SalesConnected} />
    // <Route exact path="/cohort" component={CohortConnected} />

    <Route exact path="/batchhealth" component={BatchHealthConnected} />
    <Route exact path="/customers" component={CustomersConnected} />
    // <Route exact path="/leads" component={LeadsConnected} />
    // <Route exact path="/sessions" component={SessionsConnected} />

    <Route exact path="/leadsDetails" component={LeadsDetails} />
    <Route exact path="/renewalAnalysis" component={RenewalAnalysis} />
    <Route exact path="/renewalAnalysisReport" component={RenewalAnalysisReport} />

    <Route path="/Dashboard/statsCard" component={StatsCardConnected} />
    <Route path="/Dashboard/earningGraph" component={EarningGraphConnected} />
    <Route path="/Dashboard/notifications" component={NotificationsConnected} />
    <Route path="/Dashboard/workProgress" component={WorkProgressConnected} />
    <Route path="/Dashboard/twitterFeed" component={TwitterFeedConnected} />
    <Route path="/Dashboard/teamMates" component={TeamMatesViewConnected} />
    <Route path="/Dashboard/todoList" component={TodoListViewConnected} />
    <Route exact path="/simpleTables" component={SimpleTablesConnected} />
    <Route exact path="/basicElements" component={BasicElementsConnected} />
    <Route exact path="/general" component={GeneralConnected} />
    <Route path="/general/breadcrumb" component={BreadcrumbViewConnected} />
    <Route path="/general/stat" component={StatViewConnected} />
    <Route path="/general/basicProgressBars" component={BasicProgressBarConnected} />
    <Route path="/general/tabPanels" component={TabPanelConnected} />
    <Route path="/general/stripedProgressBars" component={StripedProgressBarConnected} />
    <Route path="/general/alerts" component={AlertConnected} />
    <Route path="/general/pagination" component={PaginationViewConnected} />

    <Route exact path="/expenses" component={ExpensesConnected}/>
    <Route exact path="/editexpenses/:id" component={EditExpensesConnected}/>
    <Route exact path="/partnerDashboard" component={HomeConnected}/>
    <Route exact path="/partnerReports" component={PartnerReportsConnected}/>
    // <Route exact path="/partnerAcademy" component={PartnerBBFSConnected}/>
    // <Route exact path="/partnerFootball" component={PartnerFootballConnected}/>
    // <Route exact path="/PartnerPlay" component={PartnerPlayConnected}/>
    // <Route exact path="/partnerRental" component={PartnerRentalConnected}/>
    // <Route exact path="/partnerBadminton" component={PartnerBadmintonConnected}/>
    // <Route exact path="/partnerBadmintonAcademy" component={PartnerBadmintonAcademyConnected}/>
    <Route exact path='/partnerTournament' component={PartnerTournamentConnected}/>
    // <Route exact path="/partnerSummer" component={PartnerSummerConnected}/>
    // <Route exact path="/partnerSummerBadminton" component={PartnerSummerBadmintonConnected}/>
    // <Route exact path="/partnerBadmintonPlay" component={PartnerBadmintonPlayConnected}/>
    // <Route exact path="/partnerBFC" component={PartnerBFCConnected}/>
    // <Route exact path="/bfcKidslist" component={PartnerKidslistConnected}/>

    <Route exact path="/crud/createFixture" component={CreateFixtureConnected}/>
    <Route path='/crud/editFixture/:id' component={EditFixtureConnected}/>
    <Route exact path="/crud/addTournamentTeamMember" component={AddTournamentTeamMemberConnected}/>

    // <Route exact path="/crud/createFixture" component={CreateFixtureConnected}/>
    <Route  path='/crud/customerDetails/:id/:page?' component={CustomerDetailsConnected}/>
    <Route  path='/targetDetails' component={TargetDetailsConnected}/>
    // <Route path='/crud/editFixture/:id' component={EditFixtureConnected}/>
    <Route path='/crud/absenteeReason/:id' component={AbsenteeReasonConnected}/>
    <Route exact path="/crud/addRental" component={AddRentalConnected}/>
    <Route exact path="/crud/checkin" component={CheckIn}/>
    <Route exact path="/crud/checkout" component={CheckOut}/>
    
    <Route exact path="/crud/addlead" component={AddLeadConnected}/>
    <Route exact path="/crud/addleadbulk" component={LeadsBulkConnected}/>
    <Route exact path="/crud/addPlace" component={AddNearbyPlaceConnected}/>
    <Route exact path="/crud/editPlace/:id" component={EditPlaceConnected}/> 
    <Route exact path="/crud/addTournamentTeamMember/:tournament_id/:team_id/:team_name" component={AddTournamentTeamMemberConnected}/>
    <Route exact path="/crud/addTournament" component={AddTournamentConnected}/>
    <Route exact path="/crud/addTeam" component={AddTeamConnected}/>
    <Route path='/crud/viewTournament/:id' component={ViewTournamentConnected}/>

    <Route path='/crud/addCompetition/:id/:name' component={AddCompetitionConnected}/>
    <Route path='/crud/viewCompetition/:id/:section' component={ViewCompetitionConnected}/>
    <Route path='/crud/addCompetitionStructure/:id' component={AddCompetitionStructureConnected}/>
    <Route path='/crud/addCompetitionExpense/:id' component={AddCompetitionExpenseConnected}/>
    <Route path='/crud/editCompetitionExpense/:id' component={EditCompetitionExpenseConnected}/>
    <Route path='/crud/addCompetitionTeam/:id' component={AddCompetitionTeamConnected}/>
    <Route path='/crud/editCompetitionTeam/:id' component={EditCompetitionTeamConnected}/>
    <Route path='/crud/deleteCompetitionTeam/:id' component={DeleteCompetitionTeamConnected}/>

    <Route exact path="/crud/addSubscription" component={AddSubscriptionConnected}/>
    <Route exact path="/crud/addSubscriptionForPPG" component={AddSubscriptionPPGConnected}/>
    <Route path='/crud/addTournamentTeam/:id' component={AddTournamentTeamConnected}/>
    <Route path='/crud/addTournamentFixture/:id' component={AddTournamentFixtureConnected}/>
    <Route path='/crud/addTournamentTasks/:id' component={AddTournamentTasksConnected}/>
    <Route exact path="/crud/hostGame" component={HostGameConnected}/>
    <Route exact path="/crud/editHostedGame/:id" component={EditHostedGameConnected}/>
    <Route exact path="/partnerNotification" component={PartnerNotificationConnected}/>
    <Route path='/crud/cancelSession/:id' component={CancelSessionConnected}/>
    <Route path='/crud/deleteFixture/:id' component={DeleteFixtureConnected}/>
    <Route path='/crud/deleteTournament/:id' component={DeleteTournamentConnected}/>
    <Route path='/crud/deleteMatch/:id' component={DeleteMatchConnected}/>
    <Route path='/crud/deleteTeammember/:id' component={DeleteTeammemberConnected}/>
    <Route path='/crud/deleteTeam/:id/:team' component={DeleteTeamConnected}/>
    <Route path='/crud/editTournament/:id' component={EditTournamentConnected}/>
    <Route path='/crud/editTeam/:id' component={EditTeamConnected}/>
    <Route path='/crud/editLead/:id' component={EditLeadConnected}/>
    <Route path='/crud/childProfile/:id' component={ChildProfileConnected}/>
    <Route path='/crud/editProfile/:id' component={EditProfileConnected}/>
    <Route path='/crud/editMatch/:id' component={EditMatchConnected}/>
    <Route path='/crud/editStats/:id' component={EditStatsConnected}/>
    <Route path='/crud/feedbackStatus/:id/:types' component={FeedbackStatusConnected}/>
    <Route path='/crud/scheduleDemo/:id' component={ScheduleDemoConnected}/>
    <Route path='/crud/editTournamentSubscription/:id/:amount_paid' component={EditTournamentSubscriptionConnected}/>
    <Route path='/crud/addEvent' component={AddEventConnected}/>
    <Route path='/crud/editEvent/:id' component={EditEventConnected}/>
    <Route path='/crud/cancelBooking/:id' component={CancelBookingConnected}/>
    <Route path='/crud/unblockingCourts/:id' component={UnblockingCourtsConnected}/>
    
    // <Route path='/crud/tournamentPricing/:id' component={TournamentPricingConnected}/>

    <Route path='/crud/sessionObjective/:id' component={SessionObjectiveConnected}/>
    <Route exact path='/crud/addBulkBooking' component={AddBulkBookingConnected}/>
    <Route exact path='/crud/editCourtPricing/:id/:booking_allowed' component={EditCourtPricingConnected}/>
    <Route exact path='/crud/editRevenueTarget' component={EditRevenueTargetConnected}/>
    <Route exact path='/crud/updateCourtBooking/:id' component={UpdateCourtBookingConnected}/>
    <Route exact path='/crud/foodRental' component={FoodRentalConnected}/>
    <Route exact path='/partnerrevenue' component={DailyRevenueConnected}/>
    <Route exact path='/marketing' component={MarketingConnected}/>

    <Route exact path='/crud/tickets' component={TicketStatusConnected}/>
    <Route exact path='/crud/calls' component={CallStatusConnected}/>
    <Route exact path='/responseleads' component={ResponseLeadsConnected}/>
    <Route path='/partnercourtbooking' component={PartnerCourtBookingConnected}/>
    <Route path='/crud/updateRental/' component={UpdateRentalConnected}/>
    <Route path='/partnerbulkbooking' component={PartnerBulkBookingConnected}/>

    <Route path='/crud/addVenue' component={CreateVenueConnected}/>
    <Route path='/venues' component={VenueCommonConnected}/>
    <Route path='/crud/editVenue/:id' component={EditVenueConnected}/>
    <Route path='/crud/editCourt/:id' component={EditCourtConnected}/>
    <Route path='/crud/addCourt/:id' component={AddCourtConnected}/>
    <Route path='/crud/courtList/:id' component={CourtList}/>
    <Route path='/crud/addBuddy' component={AddBuddyConnected}/>
    <Route path='/crud/updateBuddy/:id' component={UpdateBuddyConnected}/>

    <Route path='/crud/addLocation' component={AddLocationConnected}/>

    <Route path='/crud/addItem' component={AddInventoryItemConnected}/>
    <Route path='/crud/addEntry' component={AddInventoryEntryConnected}/>
    
    <Route path='/allocation' component={PartnerAllocationConnected}/>

    <Route path='/venueLanding' component={VenueListConnected}/>
    <Route path='/venue/:id' component={VenueDetailsConnected}/>
    <Route path='/venueInfo/:id' component={VenueInfoConnected}/>

    <Route path='/customerList' component={CustomerListConnected}/>
    <Route path='/customerBasicList' component={CustomerBasicList}/>
    <Route path='/batchHealthCustomers' component={BatchHealthCustomers}/>
    <Route path='/collectionList' component={CollectionListConnected}/>
    <Route path='/collectionDetails' component={CollectionDetailsConnected}/>
    <Route path='/revenueList' component={RevenueListConnected}/>
    <Route path='/revenueDetails' component={RevenueDetailsConnected}/>
    <Route path='/revenueBreakup' component={RevenueBreakupConnected}/>
    <Route path='/bookingList' component={BookingListConnected}/>
    <Route path='/bookingSourceList' component={BookingSourceListConnected}/>

    <Route path='/expenseLanding' component={ExpenseReportConnected}/>
    <Route path='/crud/addExpenseTarget' component={AddExpenseTargetConnected}/>
    <Route path='/crud/expenseRecords/:id' component={ExpenseRecordsConnected}/>
    <Route path='/expenseList' component={ExpenseListConnected}/>
    <Route path='/expenseDetails' component={ExpenseDetailsConnected}/>
    // <Route path='/crud/editTarget' component={EditTargetConnected}/>

    <Route path='/courtBookingList' component={CourtBookingListConnected}/>
    <Route path='/bulkBookingList' component={BulkBookingListConnected}/>
    <Route path='/equipmentRentalList' component={EquipmentRentalListConnected}/>
    <Route path='/itemsSoldList' component={ItemsSoldListConnected}/>

    <Route path='/customerFeedback' component={CustomerFeedbackConnected}/>

    <Route path='/bulkpause' component={BulkPauseConnected}/>


  </Switch>
);

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/app/routes/MainRoutes.js